import api from '@/services/api'
import type { EventsResponse } from './types.ts'

export const EventsV2Service = {
  fetchEvents(page: number = 0) {
    return api.get<EventsResponse>(`/v2/events?page=${page}`)
  },
}
